import { CmsApiError } from '@/services/cmsApiClient';
import type { CmsGender } from '@/types/registration';
import { normalizeMbi } from '@/utils/mbi';
import { normalizeName } from '@/utils/name';
import type { WregIntakeForm } from './screens/wregIntakeFields';

const CMS_GENDERS: CmsGender[] = ['male', 'female', 'other', 'unknown'];

const TERMINAL_POLL_STATUSES = new Set([401, 403, 404, 422]);

const toCmsGender = (gender: string): CmsGender => {
  const normalised = gender.trim().toLowerCase();
  return CMS_GENDERS.find((g) => g === normalised) ?? 'unknown';
};

const buildCmsIdentity = (form: WregIntakeForm, birthDate: string) => ({
  mbi: normalizeMbi(form.mbi),
  patientName: { family: normalizeName(form.last), given: [normalizeName(form.first)] },
  gender: toCmsGender(form.gender),
  birthDate,
});

const errStatus = (err: unknown): string | number =>
  err instanceof CmsApiError ? (err.status ?? 'unknown') : 'unknown';

const pollErrStatus = (err: unknown): number | undefined =>
  err instanceof CmsApiError ? err.status : undefined;

const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export { TERMINAL_POLL_STATUSES, buildCmsIdentity, errStatus, pollErrStatus, sleep, toCmsGender };
